import React from "react";
import styled from "styled-components";
import { PropTypes } from "prop-types";

const Wrapper = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: stretch;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

const BusPriceExampleWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

BusPriceExampleWrapper.propTypes = {
  children: PropTypes.node,
};

export default BusPriceExampleWrapper;
